module.exports = __webpack_public_path__ + "static/img/logo41.d720e1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo41.png
// module id = NRHz
// module chunks = 1